<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Add New Category</h5>
                    <form class="forms-sample">
                        <b-form-group label="Category Name">
                            <b-form-input v-model="category.name" 
                                          type="text" 
                                          placeholder="Name">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Description">
                            <b-form-textarea v-model="category.description" 
                                             :rows="3"
                                             :max-rows="6"
                                             placeholder="Description">
                            </b-form-textarea>
                        </b-form-group>
                        <b-button variant="success" 
                                  class="mr-2"
                                  v-on:click="handleBtnSave">
                                  Add
                        </b-button>
                        <b-button variant="light" 
                                  v-on:click="handleBtnCancel">
                                  Cancel
                        </b-button>
                    </form>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import { mapActions } from'vuex'
import { required } from 'vuelidate/lib/validators'
import CategoryBaseForm from './CategoryBaseForm'
export default{
  name: 'categoryaddfrom',
  extends: CategoryBaseForm,
  created() {
      this.setAction('categories/addCategoryAction');
  },
  validations: {
      category: {
            name: {
                required
            }
        }
  },
  methods: {

  }
}
</script>